import React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import CollectionItem from './CollectionItem';
import { useArchivalCollections } from './ctx-utils';
import OriginatorFilterActive from './originator-filter-active';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridTitle: {
      backgroundColor: theme.palette.secondary.main,
      color: 'white',
      fontWeight: 'bold',
      fontSize: 18,
      height: 60,
      lineHeight: '60px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      zIndex: 1000,
      position: 'sticky',
      top: 0,
      padding: '0 16px',
      width: '100%',
    },
  })
);

const CollectionsList = () => {
  const { collections } = useArchivalCollections();
  const classes = useStyles();

  return (
    <div>
      <div className={classes.gridTitle}>Fondy</div>
      <OriginatorFilterActive />
      <div style={{ padding: '0 16px' }}>
        {collections.map((f) => (
          <CollectionItem key={f.id} collection={f} />
        ))}
      </div>
    </div>
  );
};

export default CollectionsList;
